module.exports = __webpack_public_path__ + "static/media/ic_small_close_inverse.c1789885.svg";